/**
 * Texto de la columna `type` de las tablas: tipos de solicitud o de suministro
 * y, en Usuarios ADS, los roles de la persona («Back Office», «Comercial»…).
 *
 * Lo comparten la tabla de escritorio, las tarjetas móviles y la impresión para
 * que las tres muestren lo mismo. Admite varios valores (array o separados por
 * comas, como una persona con dos roles) y traduce cada clave de
 * `common.requestTypes`. Un valor que ya viene resuelto por el back (p. ej. el
 * tipo de cuenta "Vertical y Horizontal") se muestra tal cual: `t()` devuelve
 * la clave cuando no existe, no una cadena vacía, así que se comprueba con
 * `te()` (ADSREC-0008).
 */
export const typeLabel = (value, otherAction, { t, te }) => {
  const translate = (key) => (te(`common.requestTypes.${key}`) ? t(`common.requestTypes.${key}`) : key)
  const types = Array.isArray(value)
    ? value
    : String(value ?? '').split(',').map((type) => type.trim()).filter(Boolean)

  const labels = types.map((type) => {
    if (type !== 'other_type' || !otherAction) return translate(type)
    return `${translate(type)} - ${translate(otherAction)}`
  })

  return labels.join(', ') || '-'
}
